module.exports = __webpack_public_path__ + "static/collection-31de8bf2f978e9fe127e087d3f66ef91.mp4";